import styled from "styled-components"

export const FeaturesStyles = styled.section`
  padding: var(--sectionPadding) var(--borderSpacing);
  color: #fff;
  /* background-color: #000; */

  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='0.3' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(13.9) translate(-928.06 -696.04)'%3E%3Cuse fill='%23fcfcfc' href='%23s' y='2'/%3E%3Cuse fill='%23fcfcfc' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s'/%3E%3Cuse fill='%23f7f7f7' href='%23s' x='2'/%3E%3Cuse fill='%23f7f7f7' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(13.9) translate(-928.06 -696.04)'%3E%3Cg fill='%23f5f5f5'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(13.9) translate(-928.06 -696.04)'%3E%3Cg fill='%23f5f5f5'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(13.9) translate(-928.06 -696.04)'%3E%3Cg fill='%23f2f2f2'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(13.9) translate(-928.06 -696.04)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23efefef'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(13.9) translate(-928.06 -696.04)'%3E%3Cg fill='%23FFAB1C'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(13.9) translate(-928.06 -696.04)'%3E%3Cg fill='%23FFAB1C'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(13.9) translate(-928.06 -696.04)'%3E%3Cg fill='%23FFAB1C'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;

  .features__container {
    width: calc(100% + 60px);
    transform: translateX(-30px);
    /* max-width: 1230px; */
    margin-left: auto;
    margin-right: auto;

    @media (min-width: 1024px) {
      width: calc(100% + 150px);
      transform: translateX(-75px);
    }

    @media (min-width: 1152px) {
      width: 100%;
      transform: translateX(0);
    }

    &--scroll {
      overflow-x: scroll;
      display: flex;
      scroll-snap-type: x mandatory;

      &::-webkit-scrollbar {
        width: 14px;
        height: 14px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ffc400;
        border-radius: 0px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #ffc400;
      }
      &::-webkit-scrollbar-track {
        background: #505050;
        border-radius: 0px;
      }

      @media (min-width: 1152px) {
        overflow-x: visible;
        flex-wrap: wrap;
        justify-content: start;
      }
    }
  }

  .features__title {
    width: 100%;
    background: #f8f7f7;
    font-size: 30px;
    font-weight: 900;
    color: #000;
    margin: 0 0 40px 0;
    padding: 15px 40px;

    display: flex;
    justify-content: start;
    border-radius: 30px;
    span {
      color: var(--primary);
    }

    @media (max-width: 1151px) {
      border-radius: 0;
    }
  }

  .features__item {
    flex: 0 0 80%;
    min-height: 408px;
    /* background-color: #000; */
    margin-right: 8px;
    margin-left: 8px;
    overflow: hidden;
    scroll-snap-align: start;
    scroll-margin-left: 25px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
      rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;

    @media (min-width: 414px) {
      min-height: 434px;
    }

    @media (min-width: 768px) {
      min-height: 500px;
    }

    @media (min-width: 1024px) {
      min-height: 600px;
    }

    @media (min-width: 1152px) {
      min-height: 500px;
    }

    &:hover,
    &:focus {
      cursor: pointer;

      h2,
      p {
        color: #fff;
      }

      .features__item--img {
        transform: scale(1.1);
      }
    }

    > a {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: flex-end;
      position: relative;
      text-decoration: none;
    }

    &--img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      transition: transform 0.3s ease;
    }

    &--content {
      width: 100%;
      position: relative;
      z-index: 2;
      padding: 20px;
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 0) 100%
      );

      > * {
        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }

      > h2 {
        color: #fff;
        font-size: var(--h2);
        margin-bottom: 20px;
      }

      > p {
        color: #fff;
        font-size: var(--p);
        margin-bottom: 40px;
      }
    }

    @media (min-width: 414px) {
      min-height: 434px;
    }

    @media (min-width: 768px) {
      flex-basis: 65%;
      min-height: 500px;
      margin-left: 15px;
      margin-right: 15px;
    }

    @media (min-width: 1024px) {
      flex-basis: 60%;
      min-height: 500px;
      margin-left: 20px;
      margin-right: 20px;
    }

    @media (min-width: 1152px) {
      flex: 0 0 calc((100% / 3) - 27px);
      margin-bottom: 40px;
      scroll-margin-left: 0;

      &:nth-of-type(3n + 0) {
        margin-right: 0;
      }
    }

    &:nth-child(1) {
      margin-left: 30px;

      @media (min-width: 1024px) {
        margin-left: 75px;
      }

      @media (min-width: 1152px) {
        margin-left: 0;
      }
    }

    &:last-child {
      position: relative;

      &:after {
        content: "";
        position: absolute;
        width: 30px;
        height: 30px;
        background-color: transparent;
        right: -30px;
        bottom: 0;

        @media (min-width: 1024px) {
          right: -75px;
          width: 75px;
        }

        @media (min-width: 1152px) {
          display: none;
        }
      }
    }
  }
`
